import * as constants from './constants';
import controller from './controller';
import { partnerActions as partnerMobxActions } from './partnerStore';

const dispatchFail = (dispatch, failType, error, payload) => {
  dispatch({
    type: failType,
    payload: {
      error,
      ...payload,
    },
  });
  throw error;
};

export function resetError() {
  return dispatch => dispatch({
    type: constants.RESET_ERROR,
    payload: { error: undefined },
  });
}

// блок crud партнёров
export function getPartnersList(params) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_PARTNERS,
      payload: { error: undefined, listByServiceId: params?.serviceId ?? null, loadingList: true },
    });

    return controller.getPartnerList(params).then(response => {
      if (response.errorData) {
        return dispatchFail(
          dispatch,
          constants.FETCH_PARTNERS_FAIL,
          response.errorData,
          { listByServiceId: undefined, loadedList: false, list: [], loadingList: false }
        );
      }

      return dispatch({
        type: constants.FETCH_PARTNERS_SUCCESS,
        payload: { list: response.data, loadedList: true, error: undefined, loadingList: false },
      });
    });
  };
}

export function getPartnerInfo(partnerId) {
  return dispatch => controller.getPartner(partnerId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_PARTNER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_PARTNER_SUCCESS,
      payload: { item: response.data, error: undefined },
    });
  });
}

export function checkDomainFree(domain) {
  return dispatch => controller.checkDomainFree(domain).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CHECK_PARTNER_DOMAIN_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.CHECK_PARTNER_DOMAIN_SUCCESS,
      payload: { isFreeResponse: response.data, error: undefined },
    });
  });
}

export function createPartner(data) {
  return dispatch => controller.createPartner(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_PARTNER_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков партнёров (селекторы кэшируют на сессию)
    partnerMobxActions.clearPartnerList();
    return dispatch({
      type: constants.CREATE_PARTNER_SUCCESS,
      payload: { item: response.data, error: undefined },
    });
  });
}

export function updatePartner(data) {
  return dispatch => controller.updatePartner(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_PARTNER_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков партнёров (селекторы кэшируют на сессию)
    partnerMobxActions.clearPartnerList();
    return dispatch({
      type: constants.UPDATE_PARTNER_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function deletePartner(partnerId) {
  return dispatch => controller.deletePartner(partnerId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_PARTNER_FAIL, response.errorData);
    }

    // сброс MobX-кэша списков партнёров (селекторы кэшируют на сессию)
    partnerMobxActions.clearPartnerList();
    return dispatch({
      type: constants.DELETE_PARTNER_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function setLogo(file, partnerId) {
  return dispatch => controller.setLogo(file, partnerId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.SET_LOGO_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.SET_LOGO_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function getLogo() {
  return dispatch => controller.getLogo().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.GET_LOGO_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.GET_LOGO_SUCCESS,
      payload: { logo: response.data, error: undefined },
    });
  });
}

// блок привязки страховых к партнёрам
export function getPartnerInsurance(partnerId) {
  return dispatch => {
    dispatch({
      type: constants.FETCH_PARTNER_INSURANCE,
      payload: { error: undefined, partnerInsurancePartnerId: partnerId },
    });

    return controller.getPartnerInsurance(partnerId)
      .then(response => {
        if (response.errorData) {
          return dispatchFail(
            dispatch,
            constants.FETCH_PARTNER_INSURANCE_FAIL,
            response.errorData,
            { partnerInsurancePartnerId: undefined }
          );
        }

        return dispatch({
          type: constants.FETCH_PARTNER_INSURANCE_SUCCESS,
          payload: { partnerInsurance: response.data, partnerInsurancePartnerId: partnerId, error: null },
        });
      });
  };
}

export function clearPartnerInsurance() {
  return {
    type: constants.CLEAR_PARTNER_INSURANCE,
    payload: { partnerInsurance: [], partnerInsurancePartnerId: undefined, error: null },
  };
}

export function createPartnerInsurance(data) {
  return dispatch => controller.createPartnerInsurance(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_PARTNER_INSURANCE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.CREATE_PARTNER_INSURANCE_SUCCESS,
      payload: { error: null },
    });
  });
}

export function updatePartnerInsurance(data) {
  return dispatch => controller.updatePartnerInsurance(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_PARTNER_INSURANCE_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_PARTNER_INSURANCE_SUCCESS,
      payload: { error: null },
    });
  });
}

export function deletePartnerInsurance(partnerInsuranceId) {
  return dispatch => controller.deletePartnerInsurance(partnerInsuranceId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_PARTNER_INSURANCE_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_PARTNER_INSURANCE_SUCCESS, payload: { error: null } });
  });
}
